import { Injectable, Injector } from '@angular/core';

import { SummaryService } from './summary.service';
import { BaseReportService } from './baseReport.service';
import type { IGetReportData, TReportOptions, TSummaryTripDailyValues } from '@shared/models';
import { Constants } from '@shared/models';
const DateTimeFormats = Constants.DateTimeFormats;

@Injectable()
export class ReportTripSummaryService extends BaseReportService implements IGetReportData {
    private summaryService: SummaryService;

    constructor(injector: Injector) {
        super(injector);
        this.summaryService = injector.get(SummaryService);
    }

    public async getReportData(): Promise<any> {
        const allRows: any[] = [];
        let reportColValues: string[];
        let rowInfo: any;
        let totalTrips = 0;
        let dailyValues: TSummaryTripDailyValues[] = [];

        // Get the daily values from the summary service.
        try {
            const startingDate = this.options.startingDate;
            const endingDate = this.options.endingDate;
            const obj = await this.summaryService.getTripsByDateRange(startingDate!, endingDate!);

            dailyValues = obj.dailyValues as TSummaryTripDailyValues[];
        } catch (error) {
            throw new Error('Error in ReportTripSummaryService. Unable to get daily values: ' + error);
        }

        // Process the daily values to build the report rows.
        try {
            for (const daily of dailyValues) {
                const numTrips = daily.count;
                const driver = daily.metadata.driverFullName;
                // let numTickets = 0;
                // let driver = '';
                // let completedDate = this.dateService.getMinimumDate();

                // const numTrips = daily.count;

                // daily.date is already Timestamp
                const isoString = daily.date.toDate().toISOString();
                const timestamp = this.dateService.parse(isoString, DateTimeFormats.ShortDate);
                const date = this.formatDateTime(timestamp);

                reportColValues = [date, numTrips.toString(), driver];
                rowInfo = this.buildRowInfo(reportColValues, 'data');
                allRows.push(rowInfo);

                totalTrips += numTrips;

                // for (const trip of daily.trips) {
                //     driver = trip.driver;
                //     // completedDate = trip.completedDate;
                //     numTickets += trip.ticketUids.length;
                // }

                // // const date = this.formatDateTime(completedDate);
                // const timestamp = this.dateService.parse(daily.date, DateTimeFormats.ShortDate);
                // const date = this.formatDateTime(timestamp, DateTimeFormats.MediumDate);

                // reportColValues = [ date, driver, numTrips.toString(), numTickets.toString() ];
                // rowInfo = this.buildRowInfo(reportColValues, 'data');
                // allRows.push(rowInfo);

                // totalTickets += numTickets;
                // totalTrips += numTrips;
            }

            // Now show a blank row.
            reportColValues = [' ', ' ', ' '];
            rowInfo = this.buildRowInfo(reportColValues, 'data');
            allRows.push(rowInfo);

            // Show the summary row.
            // reportColValues = [ 'Summary:', 'Total Trips: ' + totalTrips.toString(), 'Total Tickets: ' + totalTickets.toString() ];
            reportColValues = ['Summary:', 'Total Trips: ' + totalTrips.toString()];
            rowInfo = this.buildRowInfo(reportColValues, 'summary');
            allRows.push(rowInfo);

            // End of report data.
            allRows.push(undefined);
            const reportData = { 'data': allRows };
            return reportData;
        } catch (error) {
            throw new Error('Error in ReportTripSummaryService. Unable to build the report: ' + error);
        }
    }
}
